import ReachTabsPrimitive from './ReachTabs';

export const ReachTabs = ReachTabsPrimitive.Root;
export const ReachTabsList = ReachTabsPrimitive.List;
export const ReachTab = ReachTabsPrimitive.Tab;
export const ReachTabPanels = ReachTabsPrimitive.Panels;
export const ReachTabPanel = ReachTabsPrimitive.Panel;

export { default as ReachTabsPrimitive } from './ReachTabs';
